import axios from './http'
import qs from 'qs'
import { Base64 } from 'js-base64';
//post request
export function fetchPost(url, param) {
    // 调试：打印完整的请求 URL
    const fullUrl = axios.defaults.baseURL ? (axios.defaults.baseURL + url) : url;
    console.log('[API Request] URL:', url);
    console.log('[API Request] BaseURL:', axios.defaults.baseURL);
    console.log('[API Request] Full URL:', fullUrl);
    
    var parseData = JSON.stringify(param)
    var formData = new FormData();
    formData.append("data", encodeURI(Base64.encode(parseData)));
    return new Promise((resolve, reject) => {
        axios.post(url, formData)
            .then(response => {
                var data = Base64.decode(response.data)
                var jsonData = JSON.parse(data)

                // 只在本地和测试环境打印响应数据
                if (process.env.NODE_ENV !== 'production') {
                    console.log(`[APIresponse${url}] Data:`, jsonData);
                }
                resolve(jsonData)      
            }, err => {
                // 详细的错误信息
                const fullUrl = axios.defaults.baseURL ? (axios.defaults.baseURL + url) : url;
                console.error('[API Error] Request failed:', {
                    url: url,
                    baseURL: axios.defaults.baseURL,
                    fullUrl: fullUrl,
                    status: err.response && err.response.status,
                    statusText: err.response && err.response.statusText,
                    data: err.response && err.response.data,
                    message: err.message,
                    config: err.config
                });
                reject(err)
            })
            .catch((error) => {
                const fullUrl = axios.defaults.baseURL ? (axios.defaults.baseURL + url) : url;
                console.error('[API Error] Catch error:', {
                    url: url,
                    baseURL: axios.defaults.baseURL,
                    fullUrl: fullUrl,
                    error: error
                });
                reject(error)
            })
    })
}

//post file request
export function fetchPostFile(url, param,files) {
    var parseData = JSON.stringify(param)
    var formData = new FormData();
    formData.append("data", encodeURI(Base64.encode(parseData)));
    let oldImgUrls = [];
    for(let i=0;i<files.length;i++){
        if(files[i].file){
            
            formData.append(files[i].id+"_imgKey_"+(i+1),files[i].file,files[i].id+"_fileName."+ files[i].file.type.split("/")[1]);
        }else{
            let imgs = {
                id:files[i].id,
                url:files[i].url,
                key:files[i].id+"_imgKey_"+(i+1)+"_url"
            }
            let obj = JSON.stringify(imgs);
            oldImgUrls.push(obj);
        }
    }
    if(oldImgUrls.length>0){
        formData.append("old_image",oldImgUrls);
    }
    return new Promise((resolve, reject) => {
        let config = {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        };
        axios.post(url, formData,config)
            .then(response => {
                var data = Base64.decode(response.data)
                var jsonData = JSON.parse(data)
                resolve(jsonData)      
            }, err => {
                reject(err)
            })
            .catch((error) => {
                reject(error)
            })
    })
}


export function resetFetchPost(url, param) {
    param = qs.stringify(param)
    return new Promise((resolve, reject) => {
        axios.post(url, param)
            .then(response => {
                resolve(response.data)
            }, err => {
                reject(err)
            })
            .catch((error) => {
                reject(error)
            })
    })
}
//文件上传
// export function fetchUpload(url, param) {
//     let tmpParam
//     if(param){
//         param.append('token', Util.getCookie('user_token'))
//         tmpParam = param
//     }else{
//         let formdata = new FormData()
//         formdata.append('token', Util.getCookie('user_token'))
//         tmpParam = formdata
//     }
//     return new Promise((resolve, reject) => {
//         let config = {
//             headers: {
//                 'Content-Type': 'multipart/form-data'
//             }
//         }
//         axios.post(url, tmpParam, config)
//             .then(response => {
//                 resolve(response.data)
//             }, err => {
//                 reject(err)
//             })
//             .catch((error) => {
//                 reject(error)
//             })
//     })
// }

//get request
export function fetchGet(url, param) {
    appendToken(param)
    return new Promise((resolve, reject) => {
        axios.get(url, {
                params: param
            })
            .then(response => {
                resolve(response.data)
            }, err => {
                reject(err)
            })
            .catch((error) => {
                reject(error)
            })
    })
}

//并发顺序请求
export function fetchPostAll(arrayRequest) {
    var p = Promise.all(arrayRequest, (resolve, reject) => {})
    return p.then(function (val) {
        return new Promise((resolve, reject) => {
            resolve(val)
        })
    })

}

//追回token
// function appendToken(param){
//     let tmpParam
//     if(param){
//         param.token =  Util.getCookie('user_token')
//         tmpParam = param
//     }else{
//         tmpParam = {'token':Util.getCookie('user_token')}
//     }
//     return tmpParam
// }

//post file 新表单
export function newFormfetchPostFile(url, param,files,fieldName) {
    var parseData = JSON.stringify(param)
    var formData = new FormData();
    formData.append("data", encodeURI(Base64.encode(parseData)));
    let oldImgUrls = [];
    for(let i=0;i<files.length;i++){
        console.info(files[i])
        if(files[i].file){
            formData.append(fieldName+"_imgKey_"+(i+1),files[i].file,files[i].id+"_fileName."+ files[i].file.type.split("/")[1]);
        }
    }
    return new Promise((resolve, reject) => {
        let config = {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        };
        axios.post(url, formData,config)
            .then(response => {
                var data = Base64.decode(response.data)
                var jsonData = JSON.parse(data)
                resolve(jsonData)      
            }, err => {
                reject(err)
            })
            .catch((error) => {
                reject(error)
            })
    })
}

//宝宝足印上传多个file
export function fetchPostFileFootprint(url, param,filesIn,filseOut) {
    var parseData = JSON.stringify(param)
    var formData = new FormData();
    formData.append("data", encodeURI(Base64.encode(parseData)));
    let oldImgUrls = [];
    for(let i=0;i<filesIn.length;i++){
        console.info(filesIn[i])
        if(filesIn[i].file){
            formData.append("infoot_imgKey_"+(i+1),filesIn[i].file,filesIn[i].id+"_fileName."+ filesIn[i].file.type.split("/")[1]);
        }
    }
    for(let i=0;i<filseOut.length;i++){
        console.info(filseOut[i])
        if(filseOut[i].file){
            formData.append("outfoot_imgKey_"+(i+1),filseOut[i].file,filseOut[i].id+"_fileName."+ filseOut[i].file.type.split("/")[1]);
        }
    }
    return new Promise((resolve, reject) => {
        let config = {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        };
        axios.post(url, formData,config)
            .then(response => {
                var data = Base64.decode(response.data)
                var jsonData = JSON.parse(data)
                resolve(jsonData)      
            }, err => {
                reject(err)
            })
            .catch((error) => {
                reject(error)
            })
    })
}


// WEBPACK FOOTER //
// ./src/service/api/http-tools.js